module.exports = __webpack_public_path__ + "static_pc/img/21.f0c2915a.png";